var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobileDevice)?[(_vm.generalTableData)?_c('GenericTableMobile',{attrs:{"data":_vm.generalTableData,"tips":_vm.tips,"subTables":_vm.subTables}}):_vm._e()]:[(_vm.generalTableData)?_c('GenericTable',{attrs:{"data":_vm.generalTableData,"tips":_vm.tips,"subTables":_vm.subTables}}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }